import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface Filters {
  custom?: string[];
  interventionType?: string[];
  status?: string[];
}

function setFilters(
  draft: Draft<IInterventionData>,
  action: PayloadAction<Filters>,
) {
  draft.getAll.config.filters.custom = action.payload.custom;
  draft.getAll.config.filters.interventionType =
    action.payload.interventionType;
  draft.getAll.config.filters.status = action.payload.status;
}

export default setFilters;
